import { createTheme } from "@mui/material";
import { red } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: red[700],
      light: red[600],
      dark: red[900],
    },
    newEdit:{
      main: "d4eef6"
    },
    title: {
      main: "#d32f2f14",
      light: "#d32f2f14",
      dark: "#d32f2f14",
    },
  },
  typography: {
    fontFamily: ["Quicksand", "sans-serif"].join(","),
  },
});
